module.exports = __webpack_public_path__ + "img/cover-maurice-schreijen.c6eda11a.png";